export type EnvMode = 'local' | 'dev' | 'prod';

export const DEPLOY_MODE: EnvMode = 'local' as EnvMode;
export const REGION = DEPLOY_MODE === 'prod' ? 'us-east-1' : 'ap-northeast-1';
export const APP_PROTOCOL = DEPLOY_MODE === 'prod' ? 'https' : 'http';
export const SITE_ROOT = DEPLOY_MODE === 'prod' ? 'talktomeinkorean.com' : 'talktomeinkorean.kr';
